const fractionValues = {
  0: '0/0',
  0.125: '1/8',
  0.25: '1/4',
  0.375: '3/8',
  0.5: '1/2',
  0.625: '5/8',
  0.75: '3/4',
  0.875: '7/8',
};

const separateValue = (value) => ({
  wholeValue: parseInt(value, 10),
  fractionValue: parseFloat(value - Math.floor(value)),
});

const renderAsFraction = ({ wholeValue, fractionValue }) => {
  if (isNaN(wholeValue)) {
    return 0;
  } else if (fractionValue === 0) {
    return wholeValue;
  }
  return `${wholeValue} ${fractionValues[fractionValue]}`;
};

const prettyRenderFraction = (value) => {
  const separatedValues = separateValue(value);
  return renderAsFraction(separatedValues);
};

export { fractionValues, separateValue, renderAsFraction, prettyRenderFraction };
